// extracted by mini-css-extract-plugin
module.exports = {"monthCards":"styles_monthCards__3QQK9","monthName":"styles_monthName__2RlQm"};